const Connect = require("react-redux").connect;
const CreateAccount = require("../components/CreateAccount");
const AuthAct = require("actions/auth");

const internals = {};

internals.connect = Connect(null, {
    onSubmit: AuthAct.registerUser
});

module.exports = internals.connect(CreateAccount);



// WEBPACK FOOTER //
// ./src/routes/create-account/containers/CreateAccount.js